import axios from './axiosInstance';

export function createOrUpdateLabRequirementsApi(model) {
    return axios.put('/labRequirements', model).then(res => res.data);
}
